<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <h2 class="mt-n2 text-center">Terms of Service</h2>
    <div class="pa-2 mt-4 text-justify">
      <p>
        We've changed our Terms of Service!
      </p>
      <p>
        By checking the box below, I acknowledge that I have <strong>read</strong> and <strong>agree</strong> to the terms of the Referra Referrer App
        <router-link :to="{'name': 'login/eula'}">Terms of Service and EULA</router-link> and the
        <router-link :to="{'name': 'login/privacy'}">Privacy Policy</router-link>.
      </p>
    </div>
    <v-form ref="form" @submit.prevent="acceptClick">
      <div class="d-flex flex-column align-center">
        <v-checkbox v-model="accepted"
          label="I have read and agree."
          :rules="[required]"
          hide-details="true"
          class="mt-n1"
        />  
        <v-btn width="60%" type="submit" color="primary" class="mt-6">Continue</v-btn>
      </div>
    </v-form>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import { required } from '@/lib/validations'

export default {
  name: 'LoginAccept',

  data() {
    return {
      accepted: false,

      // validation rules
      required,
    }
  },

  computed: {
    ...mapGetters('auth', ['acceptanceKeys']),
  },

  methods: {
    ...mapActions('auth', ['acceptAgreement']),

    async acceptClick() {
      if (this.$refs.form.validate()) {
        const result = await this.acceptAgreement(this.acceptanceKeys)
        if (result.ok) {
          console.log({ accept_click: result })
          this.$router.replace({ name: 'referrals' })
        } else {
          this.$router.replace({ name: 'login' })
        }
      }
    },
  },
}
</script>
